import { Fragment, useState } from 'react'

export default function InputNumber({ isRequired, plusMinus, disabled, plusMinusSeparate, plusDisabled, name, value, onChange, minNumber, maxNumber }) {
  const [val, changeValue] = useState(value)

  function updateValue(value) {
    if(isNaN(+value)) {
      value = val
    }

    if(minNumber > value) {
      value = minNumber
    }

    if(maxNumber < value) {
      value = maxNumber
    }

    changeValue(value)
    if(typeof onChange === 'function') {
      onChange(value)
    }
  }

  return (
    <Fragment>
      { plusMinusSeparate
        ? (<span className='plus-minus-btn minus' onClick={() => { updateValue(val - 1) }}>-</span>)
        : ''
      }
      { disabled
        ? (<span className='value-container'>{val}</span>)
        : (<input type='text' required={isRequired} name={name} value={val} onChange={(e) => updateValue(e.target.value)} />)
      }
      { plusMinusSeparate
        ? (<span className={`plus-minus-btn plus ${plusDisabled ? 'disabled' : ''}`} onClick={() => { updateValue(val + 1) }}>+</span>)
        : ''
      }
      { plusMinus ? (
        <Fragment>
          <span className='plus' onClick={() => { updateValue(val + 1) }}>+</span>
          <span className='minus' onClick={() => { updateValue(val - 1) }}>-</span>
        </Fragment>
      ) : ''}
    </Fragment>
  )
}
